import { RecordContextProvider, RichTextField, useListContext, useTranslate } from "react-admin";
import { Box, Card, CardContent, CardHeader, Divider, Paper, Stack, Theme, useMediaQuery } from "@mui/material";
import { useState } from "react";

const EquipmentFileGridView = () => {

    const translate = useTranslate();
    const { data, isLoading } = useListContext<EquipmentNote>();
    const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('sm'));
    const isSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('md'));
    const [ selectedNote, setSelectedNote ] = useState<EquipmentNote | undefined>(undefined);

    if (isLoading) {
        return null;
    }

    if (!data || data.length === 0) {
        return (
            <Paper>
                No data found.
            </Paper>
        )
    }

    return (
        <Box>
            Developing
        </Box>
    );

    // return (
    //     <Box
    //         sx={{
    //             display: "flex",
    //             flexFlow: isXSmall ? "column" : "row",
    //         }}
    //     >
    //         <Box
    //             sx={{
    //                 px: 1,
    //                 maxWidth: {
    //                     xs: "90vw",
    //                     md: "200px",
    //                 },
    //                 overflowX: {
    //                     xs: "scroll",
    //                     md: "auto",
    //                 },
    //                 minHeight: {
    //                     xs: undefined,
    //                     md: "600px",
    //                 },
    //                 maxHeight: {
    //                     xs: undefined,
    //                     md: "1000px",
    //                 },
    //                 overflowY: {
    //                     xs: "auto",
    //                     md: "scroll",
    //                 },
    //             }}
    //         >
    //             <Stack
    //                 spacing={2} direction={isXSmall ? "row" : "column"}>
    //                 {data.map(record => (
    //                     <RecordContextProvider key={record.id} value={record}>
    //                         <Paper sx={{ p: 5, m: 1, wordBreak: "break-word", }} onClick={() => setSelectedNote(record)}>
    //                             {record.title}
    //                         </Paper>
    //                     </RecordContextProvider>
    //                 ))}
    //             </Stack>
    //         </Box>
    //         <Box
    //             sx={{
    //                 flexGrow: 1,
    //                 pl: {
    //                     sm: 0,
    //                     md: 1,
    //                 },
    //                 pt: {
    //                     sm: 1,
    //                     md: 0,
    //                 },
    //                 height: {
    //                     xs: "70vh",
    //                     md: undefined,
    //                 },
    //             }}
    //         >
    //
    //             {/*</Grid>*/}
    //             {/*<Grid sm={12} md={8}>*/}
    //             {! selectedNote && (
    //                 <Paper>Select note to view</Paper>
    //             )}
    //             {!! selectedNote && (
    //                 <RecordContextProvider key={selectedNote.id} value={selectedNote}>
    //                     <Card sx={{ height: "100%" }}>
    //                         <CardHeader title={<Box sx={{ wordBreak: "break-word"}}>{selectedNote.title}</Box>} />
    //                         <Divider />
    //                         <CardContent sx={{ height: "100%" }}>
    //                             <iframe
    //                                 height="90%"
    //                                 width="100%"
    //                                 src="https://5hrldw.sharepoint.com/sites/HomeCloudData/_layouts/15/embed.aspx?uniqueId=3f9aa5b9-3820-4e7f-a8a8-d1bb026e63b1&access_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBfZGlzcGxheW5hbWUiOiI2dW9oay5jb20iLCJhdWQiOiIwMDAwMDAwMy0wMDAwLTBmZjEtY2UwMC0wMDAwMDAwMDAwMDAvNWhybGR3LnNoYXJlcG9pbnQuY29tQDE0NDFmYjczLTkwNzMtNGViOC05ODY4LTA0ZDRlNzFlNDMxNyIsImNpZCI6IjhRU21SaFBDU1J2YWEwem9xOVdRRnc9PSIsImVuZHBvaW50dXJsIjoiZ2RGdmxpL2gzb1llUHFML002bjVTK0VIZHZEWXVSYmhuWmFZbDl5TU1Rbz0iLCJlbmRwb2ludHVybExlbmd0aCI6IjExOCIsImV4cCI6IjE3MTM0MzUxNTUiLCJpcGFkZHIiOiIyMC4xOTAuMTY5LjI0IiwiaXNsb29wYmFjayI6IlRydWUiLCJpc3MiOiIwMDAwMDAwMy0wMDAwLTBmZjEtY2UwMC0wMDAwMDAwMDAwMDAiLCJuYW1laWQiOiI5ZThmMWQ2MC1iMGJlLTQ0YWYtYmIxYy04YWUzNWRkYmI2NzFAMTQ0MWZiNzMtOTA3My00ZWI4LTk4NjgtMDRkNGU3MWU0MzE3IiwibmJmIjoiMTcxMzQzNDg1NSIsInJvbGVzIjoiYWxsc2l0ZXMucmVhZCBhbGxmaWxlcy53cml0ZSIsInNpdGVpZCI6IllqZGpOVGhoWlRRdFltSmlNeTAwWVRreUxXRm1OVFl0WmpaaFlqazJNVGcxTXpBdyIsInR0IjoiMSIsInZlciI6Imhhc2hlZHByb29mdG9rZW4ifQ.JYPgacfdcm7MBQc3akEFNW8pF_sbCLPHX5VqD5ObAdg#wopiToken=eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6IkRhREFmalFRbXB5T1h4MlJyS19XNWx2b0xaNCJ9.eyJhdWQiOiJ3b3BpLzVocmxkdy5zaGFyZXBvaW50LmNvbUAxNDQxZmI3My05MDczLTRlYjgtOTg2OC0wNGQ0ZTcxZTQzMTciLCJpc3MiOiIwMDAwMDAwMy0wMDAwLTBmZjEtY2UwMC0wMDAwMDAwMDAwMDBAOTAxNDAxMjItODUxNi0xMWUxLThlZmYtNDkzMDQ5MjQwMTliIiwibmJmIjoiMTcxMzQzNDg1NSIsImV4cCI6IjE3MTM0MzUxNTUiLCJpc3VzZXIiOiJmYWxzZSIsInV0aSI6ImpwQWhnSjlzM2tXZjBUSlJmMU1kQUEiLCJhcHBpZCI6IjllOGYxZDYwLWIwYmUtNDRhZi1iYjFjLThhZTM1ZGRiYjY3MSIsInRpZCI6IjE0NDFmYjczLTkwNzMtNGViOC05ODY4LTA0ZDRlNzFlNDMxNyIsIndvcGlfYXAiOiJhbGxzaXRlcy5yZWFkIGFsbGZpbGVzLndyaXRlIiwid29waV90dCI6IlByZUF1dGhUb2tlbiIsImFwcGN0eCI6IjNmOWFhNWI5MzgyMDRlN2ZhOGE4ZDFiYjAyNmU2M2IxO01NSW9kVHVrMnhacDRTTFIyUlQ3cU9HcTNsTT07RGVmYXVsdDs7MTAyQjAzQzIzOTJFRjtUcnVlOzs5ZThmMWQ2MC1iMGJlLTQ0YWYtYmIxYy04YWUzNWRkYmI2NzE7MTMyNzY4NDs0NmE2MDRmMS1jMjEzLTFiNDktZGE2Yi00Y2U4YWJkNTkwMTciLCJmaWQiOiIxODk3NTkifQ.Ep1FemZoej6k5W-NbPV-WrBdOoal6FfmxWuT9oPttQUxA6QrNqSrZgUVq6YQ4Ru9aIxUFEj5PsoKdZxFf5Rz6iPFz_ModgJ4U0XsHq8iGL_ccaLzKrQsYV4Y-ON1hYyS_gwc2qVo8UrMkKFArzLtkgvtT06UYVwdH4WF26SibyfxOhuh1Cg1ny7uI6JggXKCzRKjrSDPIc9-qtElYgH1LqFMLfvqQ5A-7w1vgmvYLsAmOf23xlxnFQZoxGlzMta_Lm6riL2a0FrCvYIHXCCXY99su3fpwnbfG6yK1m9omGj24bmYpw2p4xUyVpPwNDPVHqlmAFir66_14oXAY4AD5w"/>
    //                         </CardContent>
    //                     </Card>
    //                 </RecordContextProvider>
    //             )}
    //             {/*</Grid>*/}
    //             {/*</Grid>*/}
    //         </Box>
    //     </Box>
    // );
};

export default EquipmentFileGridView;
